import React from 'react';
import { motion } from 'framer-motion';
export function AbuStory() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-21">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-23">
          <span className="text-5xl mb-4 block" data-id="element-24">👵🏻</span>
          <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-25">
            La Historia de la Abu Aurora
          </h2>
        </motion.div>

        <div className="bg-white/80 backdrop-blur-sm p-8 md:p-12 rounded-3xl shadow-xl border border-brand-gold/20 relative" data-id="element-26">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-brand-bgAlt rounded-full flex items-center justify-center border-4 border-white shadow-sm" data-id="element-27">
            <span className="text-4xl text-brand-rose" data-id="element-28">🌸</span>
          </div>

          <div className="space-y-6 text-lg text-brand-textLight leading-relaxed pt-6" data-id="element-29">
            <p className="font-script text-2xl md:text-3xl text-brand-plum text-center mb-8" data-id="element-30">
              "Soy de Argentina, tengo 78 años, y hay algo que quiero confesarte
              desde el principio..."
            </p>

            <p data-id="element-31">
              Hubo una época en mi vida en que me sentía exactamente como tú te
              sientes ahora.
            </p>
            <p data-id="element-32">Deseaba más. Lo sabía. Lo sentía en los huesos.</p>
            <p data-id="element-33">
              Pero sin importar cuánto lo intentara, algo siempre me lo impedía.
              Un miedo que no podía nombrar. Una creencia que operaba en las
              sombras. Una sensación constante de que la vida abundante era para
              "otras personas" — no para mí.
            </p>
            <p data-id="element-34">Estudié. Busqué. Probé.</p>
            <p data-id="element-35">Hasta que entendí algo que lo cambió absolutamente todo:</p>

            <div className="my-10 p-8 bg-brand-bgAlt rounded-2xl border-l-4 border-brand-rose relative" data-id="element-36">
              <span className="absolute -top-4 -left-3 text-6xl text-brand-rose/20 font-serif" data-id="element-37">
                "
              </span>
              <p className="font-serif text-xl md:text-2xl text-brand-plum italic relative z-10" data-id="element-38">
                Tu mente subconsciente es como un jardín. Lo que plantes — con
                la técnica correcta — crece y florece. Pero si no sabes
                cultivarlo, lo que crece solo son las malezas del miedo, la duda
                y la escasez.
              </p>
            </div>

            <p data-id="element-39">
              Cuando aprendí a cultivar ese jardín interior — combinando
              sabiduría ancestral con los principios modernos de la
              neuroplasticidad — todo comenzó a cambiar.
            </p>
            <p data-id="element-40">Primero por dentro. Luego, inevitablemente, por fuera.</p>
            <p data-id="element-41">
              Prosperidad que no imaginaba posible. Una paz que no conocía. Un
              propósito que me levanta cada mañana con alegría — incluso a mis
              78 años.
            </p>
            <p data-id="element-42">
              Hoy, con el amor de mis nietas, quiero que ese mismo jardín
              florezca en tu vida.
            </p>

            <div className="mt-12 text-center space-y-4" data-id="element-43">
              <p className="font-script text-2xl md:text-3xl text-brand-plum" data-id="element-44">
                "Y tú, mi pequeña, que estás leyendo esto en este preciso
                momento... créeme que no es casualidad. Nunca lo es."
              </p>
              <p className="font-script text-4xl text-brand-rose mt-6" data-id="element-45">
                Te ama, La Abu Aurora 🌸
              </p>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-8 text-center text-brand-textLight italic" data-id="element-46">
          <p data-id="element-47">
            P.D.: Cada comentario de personas como tú que transformaron su vida
            me llena de felicidad. Espero que pronto el tuyo sea el siguiente.
          </p>
        </motion.div>
      </div>

      <div className="absolute top-1/4 -left-20 w-64 h-64 bg-brand-rose/5 rounded-full blur-3xl -z-10" data-id="element-48"></div>
      <div className="absolute bottom-1/4 -right-20 w-64 h-64 bg-brand-gold/10 rounded-full blur-3xl -z-10" data-id="element-49"></div>
    </section>;
}